<template>
  <v-card tile flat full-width fill-height class="card-center py-5" color="transparent">
    <v-card-title>
      <BrandLogoLoader />
    </v-card-title>
    <v-card-text>
      <h2>Page Not Found</h2>
      <p class="opacity mt-2">Didn't find what you're looking for?</p>
    </v-card-text>

    <v-spacer />

    <v-card-actions>
      <v-btn x-large color="primary" elevation="5" to="/vehicles" class="px-10">
        take me home
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'NotFound',

    mounted() {
      this.$router.replace("/vehicles");
    },
  }
</script>